import request from '@/util/request'

const state = {
  spotPrices: {},
  tradeTicketSpotPrices: {},
}

// getters
const getters = {
  getSpotPrices: (state) => {
    return state.spotPrices
  }
}

// actions
const actions = {
  changeEmailRequest(context, data) {
    return request({
      url: `/users/change-email-request`,
      method: 'post',
      data,
    })
  },
  getCurrentSpotPrice(context, params) {
    const provider = params && params.provider

    // If provider is specified, always use API (for config screen testing) and
    // do not publish to shared state. Otherwise (the header ticker's live fetch)
    // publish only to current spot state. Trade-ticket prices stay on their own
    // 30s refresh via getTradeTicketSpotPrice so the ticket lock is not overwritten.
    if (provider) {
      const url = `/spot-prices/${provider}`
      return request({
        url,
        method: 'get',
      }).then((resp) => {
        return resp
      })
    }

    return fetchCompanySpotPrices(context).then((resp) => {
      context.commit('SET_CURRENT_SPOT_PRICE', resp)
      return resp
    })
  },
  getTradeTicketSpotPrice(context) {
    return fetchCompanySpotPrices(context).then((resp) => {
      context.commit('SET_TRADE_TICKET_SPOT_PRICE', resp)
      return resp
    })
  },
  updateCommunicationPreferences(context, data) {
    const id = context.getters.getUserId
    return request({
      url: `/users/communication-preferences/${id}`,
      method: 'post',
      data,
    }).then((resp) => {
      context.commit(
        `SET_LOGIN_PROFILE`,
        {...context.getters.getUserProfile, ...resp.result}
      )
    })
  },
  updateUserProfile(context, data) {
    return request({
      url: `/users/current`,
      method: 'patch',
      data,
    }).then((resp) => {
      context.commit(
        `SET_LOGIN_PROFILE`,
        {...context.getters.getUserProfile, ...resp.result}
      )
    })
  }
}

// mutations
const mutations = {
  SET_CURRENT_SPOT_PRICE(state, payload) {
    state.spotPrices = payload
  },
  SET_TRADE_TICKET_SPOT_PRICE(state, payload) {
    state.tradeTicketSpotPrices = payload
  },
}

function fetchCompanySpotPrices(context) {
  const selectedCompany = context.rootGetters.getSelectedCompany
  const companyId = selectedCompany?.id
  return request({
    url: '/spot-prices',
    method: 'get',
    params: companyId ? {companyId} : {},
  })
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
